import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { confirmPasswordReset } from 'firebase/auth'
import { auth } from '../firebaseConfig'
import { Box, Button, Paper, Stack, TextField, Typography } from '@mui/material'
import medendoLogo from '../assets/medendo_logo.png'

const PasswordSetupStep: React.FC = () => {
    const { t } = useTranslation()
    const [newPassword, setNewPassword] = useState('')
    const location = useLocation()
    const navigate = useNavigate()
    const oobCode = new URLSearchParams(location.search).get('oobCode')
    const [error, setError] = useState<string | null>(oobCode ? null : 'Invalid or missing code.')
    const [success, setSuccess] = useState(false)

    const handlePasswordReset = async () => {
        if (!oobCode) {
            setError('Invalid or missing code.')
            return
        }

        try {
            await confirmPasswordReset(auth, oobCode, newPassword)
            setSuccess(true)
            console.info('Password reset confirmed successfully.')
        } catch (error) {
            console.warn('Failed to confirm password reset:', error)
            setError(t('auth.password_setup.reset_failed'))
        }
    }

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
            }}
        >
            <Paper>
                <Stack width={400} p={2}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={medendoLogo} alt="" width={200} />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Stack>
                            {error && <Typography color="error">{t('auth.password_setup.reset_failed')}</Typography>}
                            {success ? (
                                <>
                                    <Typography color="success">{t('auth.password_setup.success_message')}</Typography>
                                    <Button variant="contained" color="primary" onClick={() => navigate('/')}>
                                        {t('auth.password_setup.go_to_login')}
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Typography variant="h6">{t('auth.password_setup.title')}</Typography>
                                    <TextField
                                        type="password"
                                        label={t('auth.password_setup.password_label')}
                                        variant="outlined"
                                        value={newPassword}
                                        fullWidth
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handlePasswordReset}
                                        disabled={!newPassword}
                                    >
                                        {t('auth.password_setup.submit')}
                                    </Button>
                                </>
                            )}
                        </Stack>
                    </Box>
                </Stack>
            </Paper>
        </Box>
    )
}

export default PasswordSetupStep
